import { Component, OnInit, OnDestroy, OnChanges, SimpleChanges, input, output, signal, inject, effect } from "@angular/core";

import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { ModalModule } from "ngx-bootstrap/modal";
import { DocumentStorageComponent } from "./document-storage/document-storage.component";
import { BlastHistoryComponent } from "./blast-history/blast-history.component";
import { Dossier } from "src/app/bo/dossier";
import { WorkflowEtapeInstance } from "src/app/bo/workflowEtapeInstance";
import { Tir } from "src/app/bo/tir";
import { BlastService } from "src/app/services/blast.service";
import { UtilisateurService } from "src/app/services/utilisateur.service";

@Component({
  selector: 'app-general',
  templateUrl: './general.component.html',
  styleUrls: ['./general.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    TranslateModule,
    ModalModule,
    DocumentStorageComponent,
    BlastHistoryComponent
]
})
export class GeneralComponent implements OnInit, OnDestroy, OnChanges {
  readonly tirId = input<number>();
  readonly racine = input<Dossier>();
  readonly apiEndPoint = input<string>("");
  readonly securityIsChange = output<WorkflowEtapeInstance>();

  private readonly blastService = inject(BlastService);
  private readonly utilService = inject(UtilisateurService);

  public isBlastHistoryCollapsed = signal(false);

  constructor() {
    // app-document-storage reads utilService.currentTir to resolve its workflow steps.
    // Load it here when the parent hasn't already (e.g. when reached via the blast feature
    // rather than the projet/tir flow that sets currentTir upstream).
    effect(() => {
      const id = this.tirId();
      if (id && this.utilService.currentTir?.tirId !== id) {
        this.blastService.getBlast(id).subscribe((tir: Tir) => {
          this.utilService.currentTir = tir;
        });
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {}
  ngOnInit() {}
  ngOnDestroy() {}

  onBlastHistoryCollapseChanged(isCollapsed: boolean): void {
    this.isBlastHistoryCollapsed.set(isCollapsed);
  }

  protected onSecurityChange(event: WorkflowEtapeInstance): void {
    const steps = this.utilService.currentTir?.workflowInstance?.workflowEtapeInstances;
    if (steps) {
      const idx = steps.findIndex(o => o.workflowEtapeInstanceId === event.workflowEtapeInstanceId);
      if (idx !== -1) {
        steps[idx].accessPermission = event.accessPermission;
      }
    }
    this.securityIsChange.emit(event);
  }
}
